import script from "./CheckoutPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckoutPage.vue?vue&type=script&setup=true&lang=js"

import "./CheckoutPage.vue?vue&type=style&index=0&id=1b695fb0&lang=scss"

const __exports__ = script;

export default __exports__